import { post } from '@/utils/request'

/**
 * 设置是否显示外卖
 * @param {object} data 请求参数
 * @param {string} data.meituan_open 显示美团1 不显示0
 * @param {string} data.ele_open 显示饿了么1 不显示0
 */
export default function taoke_waimai_set(data) {
  return post('taoke_waimai_set', data)
}